import { ButtonPrimary, Spinner } from 'app/components';
import {
  StyledCtContainer,
  StyledSubtitle,
  StyledTitle,
} from '../ConsignedStep.styles';

type AwaitingComponentProps = {
  backStep: () => void;
  hideSubtitle: boolean;
};
const AwaitingComponent = ({
  backStep,
  hideSubtitle,
}: AwaitingComponentProps) => {
  return (
    <>
      <StyledCtContainer>
        <Spinner />
        <br />
        <StyledTitle>Consulta em andamento, aguarde.</StyledTitle>
        {!hideSubtitle && (
          <StyledSubtitle>
            Estamos aguardando a resposta do consignatário.
          </StyledSubtitle>
        )}
      </StyledCtContainer>
      <ButtonPrimary
        typeVariant="outline"
        onClick={backStep}
        style={{ width: '15rem', marginTop: '2rem' }}
      >
        Cancelar consulta
      </ButtonPrimary>
    </>
  );
};

export default AwaitingComponent;
